import React from 'react';
export const Table = (props) => (React.createElement("div", { className: "twds-text-xs twds-text-default twds-font-normal dark:twds-text-dark-bg", ...props }));
//# sourceMappingURL=table.js.map